/* 
    CustomOpenModalEvent and CustomCloseModalEvent helps use to close modal on back button
*/

// window.globalVariables.sortOn = false;

var customVariable = false;

const CheckIfHashExist = () => {
  return window.location.href.includes("#modal");
}

const CustomOpenModalEvent = () => {
  if (!window.location.href.includes("#modal") && window.innerWidth < 786) {
    // history.pushState(
    //   { url: document.location.href },
    //   document.title,
    //   "#modal"
    // );
    magnificPopup = this;
  }
};

const CustomCloseModalEvent = (cb) => {
  if (window.location.href.includes("#modal")) {
    console.log("includes #modal");
    var State = history.state;
    history.replaceState(null, document.title, State?.["url"]);
    magnificPopup = null;
    customVariable = false;
    if (cb) {
      cb();
    }
  }
};

const CloseModalClick = (e) => {
  if (window.innerWidth < 786) {
    if (e) {
      if (!e.currentTarget?.classList?.contains("Exit__PopupDismiss") && !e.currentTarget?.classList?.contains("BodyType__GuideDismiss")
        && !e.currentTarget?.classList?.contains("ShoulderType__GuideDismiss")
        && !e.currentTarget?.classList?.contains("PreferredFit__GuideDismiss")
      ) {
        window.history.go(-1);
        return;
      }
      return;
    }
    //window.history.go(-1);
  }
  customVariable = false;
};

const OpenFilterCustom = () => {
  return;
  const filterElement = document.querySelector("#collection-filter-drawer");
  const pageOverlayElement = document.querySelector('.PageOverlay');
  if (!pageOverlayElement || !filterElement) return;
  if (!CheckIfHashExist()) return;

  // Make sure that the search is closed whenever a drawer is opened
  filterElement.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
  filterElement.setAttribute('aria-hidden', 'false');
  filterElement.style.maxHeight = window.innerHeight + 'px';
  document.documentElement.classList.add('no-scroll');
  disableBodyScroll(true, '[data-scrollable]');
  document.querySelector('#shopify-section-header').style.zIndex = '';

  // We attach an event to the page overlay to close it
  pageOverlayElement.classList.add('is-visible');
}

const CloseFilterOnBack = () => {
  return;
  const pageOverlayElement = document.querySelector('.PageOverlay.is-visible');
  const filterElement = document.querySelector("#collection-filter-drawer");

  if (!pageOverlayElement || !filterElement) return;

  if (filterElement.getAttribute('aria-hidden') == 'true') {
    return;
  }

  filterElement.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('no-scroll');
  disableBodyScroll(false, '[data-scrollable]');
  pageOverlayElement.classList.remove('is-visible');
  pageOverlayElement.removeEventListener('click', () => { });
}

const OpenSortCustom = () => {
  return;
  const pageOverlayElement = document.querySelector('.PageOverlay');
  const sortElement = document.querySelector("#collection-sort-popover");
  if (!pageOverlayElement || !sortElement) return;
  if (!CheckIfHashExist()) return;
  customVariable = true;
  sortElement.setAttribute('aria-hidden', 'false');

  disableBodyScroll(true, '[data-scrollable]');
  document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open
  sortElement.removeAttribute('style');
  pageOverlayElement.classList.add('is-visible');
}

const CloseSortOnBack = () => {
  return;
  const pageOverlayElement = document.querySelector('.PageOverlay.is-visible');
  const sortElement = document.querySelector("#collection-sort-popover");
  if (!pageOverlayElement || !sortElement) return;
  if (sortElement.getAttribute('aria-hidden') == 'true') {
    return;
  }
  setTimeout(() => {
    customVariable = false;
  }, 1000)
  sortElement.setAttribute('aria-hidden', 'true');
  disableBodyScroll(false, '[data-scrollable]');
  document.documentElement.classList.remove('no-scroll');
  pageOverlayElement.classList.remove('is-visible');
}

const OpenHambuger = () => {
  const pageOverlayElement = document.querySelector('.PageOverlay');
  const hamburgerMenu = document.querySelector("#sidebar-menu")
  if (!pageOverlayElement || !hamburgerMenu) return;
  if (!CheckIfHashExist()) return;

  hamburgerMenu.setAttribute('aria-hidden', 'false');

  hamburgerMenu.setAttribute('aria-hidden', 'false');
  disableBodyScroll(false, '[data-scrollable]');
  document.documentElement.classList.add('no-scroll');
  pageOverlayElement.classList.add('is-visible');
}

const CloseHamburger = () => {
  const pageOverlayElement = document.querySelector('.PageOverlay.is-visible');
  const hamburgerMenu = document.querySelector("#sidebar-menu")
  if (!pageOverlayElement || !hamburgerMenu) return;

  if (hamburgerMenu.getAttribute('aria-hidden') == 'true') {
    return;
  }
  hamburgerMenu.setAttribute('aria-hidden', 'true');
  disableBodyScroll(false, '[data-scrollable]');
  document.documentElement.classList.remove('no-scroll');
  pageOverlayElement.classList.remove('is-visible');
}


window.addEventListener("hashchange", () => {
  var ifInstanceAvailable = $.magnificPopup.instance;
  if (ifInstanceAvailable) {
    $.magnificPopup.close();
  }
});

/* END */